import axios from "axios";
import { markNetworkError, markNetworkOk } from "./connectivity";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

// Prompt AJ - Cambio 3: si una llamada nunca recibió respuesta (caída de red,
// no un 4xx/5xx del servidor), marcamos "sin conexión" para la franja fija.
// Cualquier respuesta (incluso un error del servidor) confirma que la red sí
// llega, así que limpia el estado.
// Fix BA (2026-10-08): la sesión (cookie access_token) dura 8 horas y el frontend nunca usaba
// /auth/refresh, la renovación de 7 días que el backend ya tiene. Con turnos de 12 hs, a mitad de
// guardia todo devolvía 401 "No autenticado" (medido: Brizuela, turno 07-19 del 6/10, no pudo
// subir la foto del vehículo a las 15:44). Ante un 401 se renueva la sesión UNA vez y se repite
// el pedido; varios 401 al mismo tiempo comparten una sola renovación.
let refreshing = null;
const SIN_RENOVAR = ["/auth/login", "/auth/refresh", "/auth/logout"];

api.interceptors.response.use(
  (res) => { markNetworkOk(); return res; },
  async (err) => {
    if (!err.response) markNetworkError();
    else markNetworkOk();
    const cfg = err.config;
    const url = (cfg && cfg.url) || "";
    if (err.response && err.response.status === 401 && cfg && !cfg._renovado && !SIN_RENOVAR.some((p) => url.includes(p))) {
      cfg._renovado = true;
      try {
        if (!refreshing) refreshing = api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(cfg);
      } catch {
        // Sin renovación válida (más de 7 días sin usar, o cuenta dada de baja): queda el error original.
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Algo salió mal. Reintentá.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    console.error("API validation detail:", d);
    return d.map((e) => {
      if (!e || typeof e !== "object") return JSON.stringify(e);
      const field = Array.isArray(e.loc) && e.loc.length ? e.loc[e.loc.length - 1] : "campo";
      const message = e.msg === "Field required" ? "falta completar" : e.msg;
      return `${field}: ${message || JSON.stringify(e)}`;
    }).join(" · ");
  }
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
